<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="border-bottom px-4">
    <button [cSidebarToggle]="sidebarId()" cHeaderToggler class="btn" toggle="visible"
      style="margin-inline-start: -14px" [attr.aria-label]="'layout.toggleSidebar' | transloco">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <c-header-nav class="ms-auto ms-md-0">
      <ng-container *ngTemplateOutlet="languageDropdown" />
      <ng-container *ngTemplateOutlet="themeDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>

      <!-- Pending tickets badge -->
      <div *ngIf="pendingTicketCount() > 0" class="nav-item">
        <c-badge color="danger" textColor="white">{{ 'header.pendingTickets' | transloco: { count: pendingTicketCount() } }}</c-badge>
      </div>

      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>
  </c-container>
  <c-container [fluid]="true" class="px-4">
    <c-breadcrumb-router [items]="breadcrumbs()" />
  </c-container>
</ng-container>

<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item">
    <button [caret]="false" cDropdownToggle class="py-0" [attr.aria-label]="'header.openUserMenu' | transloco">
      <c-avatar shape="rounded-1" size="md" src="./assets/images/avatars/111.png" status="success" textColor="primary"
        [alt]="'header.userAvatar' | transloco" />
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold py-2 rounded-top">
          {{ 'header.account' | transloco }}
        </h6>
      </li>
      <li>
        <a cDropdownItem routerLink="" (click)="logout()">
          <svg cIcon class="me-2" name="cilAccountLogout"></svg>
          {{ 'header.logout' | transloco }}
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle [attr.aria-label]="'header.openThemePicker' | transloco">
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
      <button (click)="colorMode.set(mode.name)" [active]="colorMode() === mode.name" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
        {{ mode.text | transloco }}
      </button>
      }
    </div>
  </c-dropdown>
</ng-template>
<ng-template #languageDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle [attr.aria-label]="'language.change' | transloco"
      class="d-flex align-items-center gap-1">
      <svg cIcon name="cilLanguage" size="lg"></svg>
      <span class="small fw-semibold text-uppercase">{{ currentLang() }}</span>
    </button>
    <div cDropdownMenu>
      @for (lang of language.languages; track lang.id) {
      <button (click)="setLanguage(lang.id)" [active]="currentLang() === lang.id" cDropdownItem>
        {{ lang.label }}
      </button>
      }
    </div>
  </c-dropdown>
</ng-template>
